"use client";
import { useEffect, useState } from 'react';
import { sendLandingEvent } from '../../lib/analytics';
import { afterNextPaint } from '../../lib/afterNextPaint';

export default function StickyCTA({ locale = 'en' }) {
  const [show, setShow] = useState(false);
  const label = { en: 'Try a free transcript', de: 'Kostenlos transkribieren', fr: 'Transcrire gratuitement' }[locale] || 'Try a free transcript';
  useEffect(() => {
    const target = document.getElementById('try-transcription');
    if (!target || !window.IntersectionObserver) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Only after the entry has scrolled above the screen, never before it.
      setShow(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  if (!show) return null;
  return <button className="mobile-sticky-cta" onClick={async () => {
    document.getElementById('try-transcription')?.scrollIntoView({ block: 'start' });
    document.querySelector('#try-transcription [data-guest-file-picker]')?.click();
    await afterNextPaint();
    sendLandingEvent('landing_cta_click', { cta_id: 'sticky_guest_entry', cta_location: 'sticky_mobile', landing_locale: locale });
  }}>{label}</button>;
}
